import { useNotification } from 'hooks'
import { getVoucherInfo } from '../api'
import { useEffect, useState } from 'react'
import { VoucherBarcodeScanner } from './VoucherBarcodeScanner'
import s from './ValidateCoupon.modules.scss'
import { VoucherInfo } from './VoucherInfo'
import { useMutation } from 'react-query'
import { formatErrorMessage } from 'utils/formatting'
import { makeCorePostRequest } from 'utils/api'
import { toVoucherPaylod } from './serializers'
import { VoucherInfoResponse } from '../interfaces'

const ValidateCoupon = () => {
  const [barcode, setBarcode] = useState<string>('')
  const [voucherInfo, setVoucherInfo] = useState<VoucherInfoResponse>(null)

  const { showNotification } = useNotification()

  const { data: voucherResponse, isLoading, refetch } = getVoucherInfo(showNotification, barcode)

  useEffect(() => {
    if (voucherResponse) {
      setVoucherInfo(voucherResponse)
    } else {
      setVoucherInfo(null)
    }
  }, [voucherResponse])

  useEffect(() => {
    if (voucherInfo) {
      if (voucherInfo.isUsed && !voucherInfo.status) {
        showNotification({
          message: 'Voucherul a fost deja utilizat.',
          type: 'error'
        })
      }
    }
  }, [voucherInfo])

  const searchVoucher = async (): Promise<void> => {
    if (barcode) {
      refetch()
    }
  }

  const clearCode = () => {
    setBarcode('')
    document.getElementById('barcode-scan-input').focus()
  }

  const validateVoucher = async values => {
    if (voucherInfo && voucherInfo.isUsed === false) {
      return await makeCorePostRequest('/sgr/voucher/consume', values)
    }
  }

  const { isLoading: isLoadingValidateVoucher, mutate } = useMutation(validateVoucher, {
    onSuccess: res => {
      setVoucherInfo(res)
      showNotification({
        message: 'Voucherul a fost folosit cu succes.',
        type: 'success'
      })
    },
    onError: res => {
      showNotification({
        message: `A aparut o eroare la utilizarea voucherului. ${formatErrorMessage(res)}`,
        type: 'error'
      })
    }
  })

  const onSubmitVoucher = () => {
    if (!voucherInfo || voucherInfo.isUsed !== false || isLoadingValidateVoucher) {
      return
    }
    mutate(toVoucherPaylod(voucherInfo))
  }

  return (
    <div className={s.mainContainer}>
      <VoucherBarcodeScanner
        barcode={barcode}
        setBarcode={setBarcode}
        searchVoucher={searchVoucher}
        clearCode={clearCode}
        isLoading={isLoading}
      />
      {voucherInfo && (
        <VoucherInfo
          voucherInfo={voucherInfo}
          onSubmitVoucher={onSubmitVoucher}
          isLoadingValidateVoucher={isLoadingValidateVoucher}
        />
      )}
    </div>
  )
}

export default ValidateCoupon
